import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { environment } from '../../environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  username!: string;
  password!: any;
  mfaToken!: any;
  codigoTokenMfa!: any;
  returnGetToken!: any;
  tenant!: string;
  errorMsg!: string;
  apiUrl = environment.API_URL + 'internal/authorization/v2/web-app-user-token';
  bodyRequest = {
    Tenant: this.tenant,
    Username: this.username,
    Password: this.password,
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept-Language': 'pt-BR'
    })
  };

  redirectUrl: any = '';
  constructor(
    private router: Router,
    private poNotification: PoNotificationService,
    private tokenService: TokenService,
  ) { }

  public async postLogin(username: string, password: any, tenant: string) {
    this.username = username;
    this.password = password;
    this.tenant = tenant;
    this.bodyRequest.Username = this.username;
    this.bodyRequest.Password = this.password;
    this.bodyRequest.Tenant = this.tenant;
    return await this.postToken();
  }

  public async postToken() {
    return await fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept-Language': 'pt-BR'
      },
      body: new URLSearchParams({
        'username': this.bodyRequest.Username,
        'password': this.bodyRequest.Password,
        'tenant': this.bodyRequest.Tenant.toLowerCase(),
        'product': '900'
      })
        .toString()
    })
      .then(response => response.json())
      .then(token => {
        if (token.access_token != undefined) {
          this.tokenService.saveTokenV2(token.access_token);
          return this.validateUserHasAuthorization();
        } else {
          throw new Error(token[0].message);
        }
      })
      .catch(err => {
        this.showAuthenticationError(err);
        return false;
      });
  }

  public async postMfa(username: string, password: any, tenant: string, mfa: any): Promise<boolean> {
    return await fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept-Language': 'pt-BR'
      },
      body: new URLSearchParams({
        'username': username,
        'password': password,
        'tenant': tenant.toLowerCase(),
        'product': '900',
        'mfa_totvs': mfa,
      })
        .toString()
    })
      .then(response => response.json())
      .then(token => {
        if (token.access_token != undefined) {
          this.tokenService.saveTokenV2(token.access_token);
          return this.validateUserHasAuthorization();
        } else {
          throw new Error(token[0].message);
        }
      })
      .catch(err => {
        this.showAuthenticationError(err);
        return false;
      });
    return false;
  }

  public validateUserHasAuthorization(): boolean {
    const token = this.tokenService.getTokenV2();

    if (!token) {
      this.tokenService.cleanVariablesStorage();
      this.router.navigate(['/login']);
      return false;
    }

    if (this.tokenService.isNotExpiredToken(token)) {
      return true;
    } else {
      this.tokenService.signOut();
    }

    return false;
  }

  logout() {
    const mostAccessedPages = localStorage.getItem('mostAccessedPages');
    
    localStorage.clear();
    sessionStorage.clear();
    
    if (mostAccessedPages) {
      localStorage.setItem('mostAccessedPages', mostAccessedPages);
    }
    
    this.router.navigate(['/']);
  }

  private showAuthenticationError(err: any) {
    if (err.message == 'Failed to fetch') {
      this.poNotification.error('Não foi possível estabelecer conexão com servidor.');
      return;
    }
    this.poNotification.error(err);
  }
}

